import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { ProjectSummaryDataService } from './data-access/project-summary-data.service';
import { ProjectSummaryTableContainerComponent } from './feature/project-summary-table-container/project-summary-table-container.component';
import { ProjectSummaryTableComponent } from './ui/project-summary-table/project-summary-table.component';

@NgModule({
    declarations: [ProjectSummaryTableContainerComponent, ProjectSummaryTableComponent],
    imports: [CommonModule, MatTableModule, MatCheckboxModule, MatIconModule, MatButtonModule, MatMenuModule],
    providers: [ProjectSummaryDataService],
    exports: [ProjectSummaryTableContainerComponent]
})
export class ProjectSummaryModule { }
